<div class="mb-3 step-1">
  <h5 class="text-primary">Reminder</h5>
  <p>Inform users of status changes</p>
  <div class="card-body px-3 py-4 bg-white border-0 rounded">
    <p>Remind applicant days before the certificate expires.</p>
    <div class="body">
      <form [formGroup]="configureRemindersForm">
        <div class="form-group">
          <label for="reminderOffsetDays" class="form-label text-muted">
            Remind before
            <i
              class="fa-solid fa-circle-info text-muted"
              placement="top"
              ngbTooltip="Remind before"></i>
          </label>
          <div class="row">
            <div class="col-4">
              <input
                type="number"
                class="form-control"
                id="reminderOffsetDays"
                placeholder="number"
                formControlName="reminderOffsetDays" />
            </div>
            <div class="days-text d-flex col-2">
              <span>Days</span>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-12">
              <p class="border p-3 rounded">
                <b>Note:</b> if the user have multiple application with the
                selected status the system will consider the recent one.
              </p>
            </div>
          </div>
          <hr />
          <div formGroupName="languageTemplate">
            <ng-container *ngFor="let language of languages">
              <span class="language-label">{{ language.name }}</span>
              <div [formGroupName]="language.locale" class="row">
                <div class="col-7">
                  <label for="subject" class="form-label text-muted">
                    Notification Title
                    <i
                      class="fa-solid fa-circle-info text-muted"
                      placement="top"
                      ngbTooltip="Notification Title"></i>
                  </label>
                  <div class="row">
                    <div class="col-7">
                      <input
                        type="text"
                        class="form-control"
                        id="subject"
                        placeholder="Title"
                        formControlName="subject" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col">
                      <div class="w-100 editor-container">
                        <div class="button-tabs">
                          <irembogov-button-group
                            class="w-100"
                            [itemList]="notificationConfigurationTabs"
                            [selectedItem]="
                              selectedNotificationConfigurationTab
                            "
                            (itemChange)="
                              selectedNotificationConfigurationTab = $event
                            "
                            [fullWidth]="true"
                            [iconAboveLabel]="false"
                            uiStyle="flat-tabs"
                            theme="irembo-blue-theme"></irembogov-button-group>
                        </div>
                      </div>
                      <div class="w-100 p-3 border rounded-bottom">
                        <label for="emailBody" class="form-label text-muted">
                          {{
                            selectedNotificationConfigurationTab === 'Email'
                              ? 'Email Body'
                              : 'SMS Body'
                          }}
                        </label>
                        <div class="row">
                          <div class="col" style="height: fit-content">
                            <quill-editor
                              [hidden]="
                                selectedNotificationConfigurationTab !== 'Email'
                              "
                              format="html"
                              id="emailBody"
                              [modules]="quillConfig"
                              class="bg-white rounded border border-light"
                              formControlName="emailBody"
                              [required]="true">
                            </quill-editor>
                            <quill-editor
                              [hidden]="
                                selectedNotificationConfigurationTab !== 'SMS'
                              "
                              format="html"
                              id="smsBody"
                              [modules]="quillConfig"
                              class="bg-white rounded border border-light"
                              formControlName="smsBody"
                              [required]="true">
                            </quill-editor>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between mt-2">
                          <div>
                            <button
                              *ngIf="
                                selectedNotificationConfigurationTab ===
                                EReminderTypes.Email
                              "
                              type="button"
                              class="btn btn-outline-primary">
                              Test
                            </button>
                          </div>
                          <div>
                            <button
                              [disabled]="
                                !this.configureRemindersForm.dirty || loading
                              "
                              (click)="saveReminderConfig()"
                              type="button"
                              class="btn btn-primary">
                              <div
                                *ngIf="loading"
                                class="spinner-border spinner-border-sm mr-2"
                                role="status"></div>
                              Save
                            </button>
                          </div>
                        </div>
                        <span
                          *ngIf="
                            selectedNotificationConfigurationTab ===
                            EReminderTypes.Email
                          "
                          class="text-muted test-label">
                          For testing The email will be sent to your login email
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <ng-container
                    *ngIf="
                      selectedNotificationConfigurationTab ===
                        EReminderTypes.Email;
                      else smsPreview
                    ">
                    <p class="preview-label">Email Preview</p>
                    <div class="card border-0 email-preview-container">
                      <div class="card-body">
                        <div class="d-flex flex-column">
                          <div class="email-content-container w-100">
                            <p class="email-subject">
                              {{
                                this.configureRemindersForm.get([
                                  'languageTemplate',
                                  language.locale,
                                  'subject'
                                ])?.value
                              }}
                            </p>
                            <div
                              class="email-body"
                              [innerHTML]="
                                this.configureRemindersForm.get([
                                  'languageTemplate',
                                  language.locale,
                                  'emailBody'
                                ])?.value
                              "></div>
                            <button class="btn btn-primary w-100 my-3">
                              Renew
                            </button>
                            <p
                              class="link-expire-text"
                              style="text-align: center">
                              This link expires in 24 hours.
                            </p>
                          </div>
                          <img
                            src="assets/images/email-preview.png"
                            alt="email-preview" />
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #smsPreview>
                    <p class="preview-label">SMS Preview</p>
                    <div
                      class="d-flex justify-content-center position-relative">
                      <div class="position-relative" style="width: fit-content">
                        <div class="position-absolute sms-message-container">
                          <div
                            class="email-body"
                            [innerHTML]="
                              this.configureRemindersForm.get([
                                'languageTemplate',
                                language.locale,
                                'smsBody'
                              ])?.value
                            "></div>
                        </div>
                        <img
                          src="assets/images/sms-preview.png"
                          alt="sms-preview"
                          style="width: 242px" />
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <hr />
            </ng-container>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
